export default function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/addLeadingZeros/index.js
// module id = 92
// module chunks = 0